import { Phone } from "lucide-react";
import { Badge } from "../../../components/tailwind/badge";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
} from "../../../components/tailwind/select";

export const PhoneNumberSelector = ({ phones, selectedNumber, onSelectionChange, currentNumber }) => {
    if (!phones.length) return null;

    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 rounded-xl bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 shadow-sm animate-fade-in-up animate-delay-75 wa-card-hover">
            <div className="flex items-center gap-3 min-w-0">
                <div className="h-10 w-10 shrink-0 rounded-xl bg-emerald-50 dark:bg-emerald-950/50 flex items-center justify-center">
                    <Phone className="h-5 w-5 text-[#0F6E56] dark:text-emerald-400" />
                </div>
                <div className="min-w-0">
                    <p className="text-xs text-gray-500 dark:text-gray-400 mb-0.5">
                        Active WhatsApp Number
                    </p>
                    <Select value={selectedNumber} onValueChange={onSelectionChange}>
                        <SelectTrigger
                            className="border-0 p-0 h-auto shadow-none focus:ring-0 text-left bg-transparent hover:bg-gray-50 dark:hover:bg-slate-800 rounded-md transition-colors"
                            data-testid="select-whatsapp-number"
                        >
                            <div className="flex items-center gap-2 min-w-0">
                                <span className="font-semibold text-gray-900 dark:text-white truncate">
                                    {currentNumber?.number || "No number selected"}
                                </span>
                                {currentNumber && (
                                    <Badge
                                        variant="secondary"
                                        className="shrink-0 bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-gray-300 text-[10px] border-0"
                                    >
                                        {currentNumber.label}
                                    </Badge>
                                )}
                            </div>
                        </SelectTrigger>
                        <SelectContent className="bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800">
                            {phones.map((num) => (
                                <SelectItem
                                    key={num.id}
                                    value={num.id}
                                    className="py-3 focus:bg-gray-50 dark:focus:bg-slate-800 cursor-pointer"
                                >
                                    <div className="flex items-center gap-3">
                                        <div className="h-2 w-2 rounded-full bg-[#0F6E56] dark:bg-emerald-400" />
                                        <span className="font-medium text-gray-900 dark:text-white">
                                            {num.number}
                                        </span>
                                        <Badge
                                            variant="secondary"
                                            className="bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-gray-400 text-[10px] border-0"
                                        >
                                            {num.label}
                                        </Badge>
                                    </div>
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            </div>
            <Badge className="self-start sm:self-auto shrink-0 bg-emerald-50 dark:bg-emerald-950/40 text-[#0F6E56] dark:text-emerald-400 border border-emerald-100 dark:border-emerald-800/50 px-3 py-1">
                {phones.length} number{phones.length !== 1 ? "s" : ""} connected
            </Badge>
        </div>
    );
};
